export default "__VITE_ASSET__NB90o8f0__"